import { useEffect, useRef } from 'react'

export function useAudio({
  source,
  repeat = false,
}: {
  source: string
  repeat?: boolean
}) {
  const audioRef = useRef<null | HTMLAudioElement>(null)

  useEffect(() => {
    async function init() {
      // Avoid calling multiple times in development mode
      if (import.meta.env.MODE.match(/development/) && audioRef.current) {
        return
      }

      if (!audioRef.current) {
        audioRef.current = new Audio(source)
        audioRef.current.loop = repeat
      }
    }

    init()
  }, [])

  const play = () => {
    audioRef.current?.play()
  }

  const stop = () => {
    if (audioRef.current?.currentTime) {
      audioRef.current.currentTime = 0
      audioRef.current.pause()
    }
  }

  return {
    play,
    stop,
  }
}
